/**
 * Parse campus.companyIDs ("1", "1,2") into numeric ids.
 */
export function parseCompanyIds(raw) {
  if (raw === null || raw === undefined || raw === "") return [];
  return String(raw)
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
    .map((s) => Number(s))
    .filter((n) => Number.isFinite(n) && n > 0);
}

/** Comma-separated ids for API, or null when empty. */
export function formatCompanyIds(ids) {
  const list = (Array.isArray(ids) ? ids : [])
    .map((id) => Number(id))
    .filter((n) => Number.isFinite(n) && n > 0);
  if (!list.length) return null;
  return list.join(",");
}

export function companyIdsLabel(raw, companiesById = {}) {
  const ids = parseCompanyIds(raw);
  if (!ids.length) return "";
  return ids
    .map((id) => {
      const c = companiesById[id];
      if (c) return c.code ? `${c.code}` : c.name;
      return String(id);
    })
    .join(", ");
}
